import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import {
  addCommonFormErrors,
  deleteCommonFormErrors,
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { GAS_METER_ID_LENGTH } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'

const useMeterInput = () => {
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const { pceNo, isEditable, errors, lastSentDate, t, gasMeterUpdate, isValidPce, canRequestMeterData } = useGasMeter({
    type: 'client',
  })
  const status = isValidPce ? 'valid' : 'error'
  const searchPceAvailableCountries = ['fr']
  const showPceSearchButton = searchPceAvailableCountries.includes(country)

  // to-do-v2: refactor this when errors are handled in the new form
  const meterIdOnBlurHandler = value => {
    const pceNo = value?.replace(/ /g, '')
    gasMeterUpdate({
      pceNo,
      meterConsent: false,
      consentDate: null,
    })

    if (country === 'it') {
      return
    }

    if (!pceNo || pceNo?.length !== GAS_METER_ID_LENGTH[country]) {
      setIsValidPce(false)
      return
    }

    dispatch({
      type: subscriptionFormActionsV2.METER_MODULE_VALIDATE_PCE_METER_SYNTAX_V2,
      meterId: pceNo,
      callback: setIsValidPce,
    })
  }

  // to-do-v2: refactor this when errors are handled in the new form
  const setIsValidPce = value => {
    gasMeterUpdate({ isValidPce: value })
    if (value === false && pceNo?.length > 0) {
      dispatch(addCommonFormErrors({ meter_id_gas: ['La syntaxe du PCE est incorrecte'] }))
    } else {
      dispatch(deleteCommonFormErrors('meter_id_gas'))
    }
  }

  return {
    meterIdOnBlurHandler,
    pceNo,
    isEditable,
    errors,
    lastSentDate,
    canRequestMeterData,
    meterStatus: pceNo ? status : null,
    showPceSearchButton,
    t,
  }
}

export default useMeterInput
